import React from 'react';

const deviceInfoContext = React.createContext({device: 'other', OS: 'other', browser: 'other'});
export default deviceInfoContext;